import React from 'react';

import { ButtonLinkType } from '../../graphql-fragments/ButtonLink';
import { getUrlFromVersatileLink } from '../../utils/sanity';
import { clsx } from '../../utils/utils';
import SmartLink from './SmartLink';
import TextLink from './TextLink';
import Video from './Video';
import * as styles from './VideoCard.module.scss';

export interface VideoCardProps {
  videoUrl: string;
  title: string;
  text: string;
  button: ButtonLinkType;
  className?: string;
}

const VideoCard = ({
  videoUrl,
  title,
  text,
  button,
  className,
}: VideoCardProps): React.ReactElement => {
  return (
    <div className={clsx(styles.videoCardContainer, className)}>
      <div className={styles.videoContainer}>
        <Video url={videoUrl} />
      </div>
      <SmartLink to={getUrlFromVersatileLink(button)} className={styles.textContainer}>
        <h3 className={styles.title}>{title}</h3>
        <p className={styles.text}>{text}</p>
        <TextLink styleOnly withArrowIcon className={styles.link}>
          {button.text}
        </TextLink>
      </SmartLink>
    </div>
  );
};

export default VideoCard;
